import axios from 'axios'
// 请求拦截器
axios.interceptors.request.use(function (config) {


  //  //headers中配置text请求
  // if (config.text === true) {
  //   config.headers["Content-Type"] = "text/plain";
  // }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

//响应拦截器
axios.interceptors.response.use(function (response) {
  // console.log(response.status);
  // 如果code是-1，说明用户已注销或者token已过期
  if (response.status == 200) {
    const data = response.data;
    if (data.code == -1) {}
  }
  return response;
}, function (err) {
  if (err.response.status === 500) {
    // console.log(err)
  }
  // 未授权
  if (err.response.status === 401) {
    // console.log(err)
  }
  if (err.response.status === 400) {
    return Promise.resolve(err.response);
  } else {
    return Promise.reject(err);
  }
});
export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js